<template>
  <div class="no-data">
    <div>
      <img class="commodity" src="../images/commodity.png" />
      <p class="des">空空如也，赶紧去逛逛吧！</p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.commodity {
  display: block;
}
.des {
  width: 168px;
  font-size: 14px;
  color: #969799;
  line-height: 20px;
  margin: 0;
  padding: 12px 0 0;
}
</style>
